import React, { ReactNode } from "react";

import { WhooshThemeColors } from "../../../../theme/restyle/theme";
import { Box, Text } from "../../../primitive";
import { Tooltip } from "../elements/Tooltip/Tooltip";

type IndicatorTooltipProps = {
  direction?: "top" | "bottom" | "left" | "right";
  trigger: ReactNode;
  indicatorSets: {
    color: WhooshThemeColors;
    number: number;
    label: string;
  }[];
};

export const IndicatorTooltip = ({
  direction,
  trigger,
  indicatorSets,
}: IndicatorTooltipProps) => {
  const tooltipContent = (
    <Box flex={1} flexDirection="row" justifyContent="space-evenly" gap={2}>
      {indicatorSets.map((indicatorSet, index) => (
        <Box
          key={index}
          flex={1}
          gap={2}
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            borderRadius={"6"}
            backgroundColor={indicatorSet.color}
            width={8}
            height={8}
            justifyContent="center"
            alignItems="center"
          />
          <Box
            width="auto"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
          >
            <Text variant="mainTiny" color="grayscale-100" numberOfLines={1}>
              {`${indicatorSet.number} ${indicatorSet.label}`}
            </Text>
          </Box>
        </Box>
      ))}
    </Box>
  );

  return (
    <Tooltip direction={direction} content={tooltipContent} trigger={trigger} />
  );
};
